import { TextHelper } from 'src/app/utils/text-helper';
import { ShopService } from './../../../../data/repository/shop-repository/shop.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss'],
})
export class PromotionComponent implements OnInit {
  SWIPE_ACTION = { RIGHT: 'swiperight', LEFT: 'swipeleft' };

  currentHappyUser = 0;
  happyUserCards: HTMLElement[] = [];
  timer;

  returnUrl: string;

  constructor(
    private textHelper: TextHelper,
    private shopService: ShopService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  ngOnInit() {
    setTimeout(() => {
      this.initialHappyUsers();
    }, 100);
  }

  back() {
    clearTimeout(this.timer);
    const url = this.textHelper.replaceDeeplinkToCorrectUrls(this.returnUrl);
    if (url) {
      this.router.navigate([url]);
    } else {
      this.shopService.backToMain();
    }
  }

  initialHappyUsers() {
    for (let i = 0; i < 5; i++) {
      this.happyUserCards[i] = document.getElementById(i.toString() + 'card');
    }
    setTimeout(() => {
      this.nextHappyUser();
    }, 5000);
  }

  nextHappyUser() {
    this.currentHappyUser = (this.currentHappyUser + 1) % 5;
    this.happyUserCards.forEach((card, i) => {
      const distance = (i - this.currentHappyUser) * 100;
      card.style.right = 'calc( ' + distance.toString() + '% + 24px )';
    });
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.nextHappyUser();
    }, 5000);
  }

  previousHappyUser() {
    if (this.currentHappyUser > 0) {
      this.currentHappyUser = (this.currentHappyUser - 1) % 5;
      this.happyUserCards.forEach((card, i) => {
        const distance = (i - this.currentHappyUser) * 100;
        card.style.right = 'calc( ' + distance.toString() + '% + 24px )';
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.nextHappyUser();
      }, 5000);
    }
  }

  swipe(action: string = this.SWIPE_ACTION.LEFT) {
    if (action === this.SWIPE_ACTION.LEFT) {
      this.previousHappyUser();
    }
    if (action === this.SWIPE_ACTION.RIGHT) {
      this.nextHappyUser();
    }
  }

  goToShop() {
    clearTimeout(this.timer);
    this.shopService.goToShopPage('promotion');
  }
}
